<!-- Molecular component for allowing the user to copy EFT info from elsewhere in the session-->
<template>
	<div class="flex flex-row gap-4">
		<CopyButton
			v-for="eftItem in filteredSessionEfts"
			:key="JSON.stringify(eftItem)"
			:name="eftItem.label"
			:button-index="eftItem.planIndex"
			@copy="onCopyButtonClick(eftItem.eft)"
		/>
	</div>
</template>

<script setup lang="ts">
import CopyButton from '../presentation/CopyButton.vue'
import { toFlatEft, useEft } from '@/mixins/eft'
import type { EFT } from '@/types'
import { computed, toRaw } from 'vue'

const { allSessionEfts } = useEft()

const emit = defineEmits<{
	(e: 'copy', eft: EFT): void
}>()

const props = defineProps<{
	activeEft: EFT | undefined
}>()

/** EFT accounts from this session that are not the active account */
const filteredSessionEfts = computed(() =>
	allSessionEfts.value.filter(
		(eft) =>
			!(
				eft.eft.routingNumber === props.activeEft?.routingNumber &&
				eft.eft.accountNumber === props.activeEft?.accountNumber &&
				props.activeEft !== undefined
			)
	)
)

/** Copy the target data to the active account */
function onCopyButtonClick(eft: EFT) {
	emit('copy', toFlatEft(structuredClone(toRaw(eft))))
}
</script>
